import { Link } from "react-router-dom";

interface NotificationItemProps {
  id: string;
  type: string;
  icon: string;
  title: string;
  body: string;
  time: string;
  isRead: boolean;
  orderId?: string;
  onRead: (id: string) => void;
}

const TYPE_META: Record<string, { label: string; tone: string }> = {
  financial: { label: "مالية", tone: "bg-red-100 text-red-600" },
  rating: { label: "تقييمات", tone: "bg-accent-100 text-accent-800" },
  store: { label: "المتجر", tone: "bg-primary-100 text-primary-700" },
  delivery: { label: "التوصيل", tone: "bg-accent-200 text-accent-900" },
  system: { label: "نظامية", tone: "bg-secondary-200 text-secondary-800" },
};

export default function NotificationItem({
  id,
  type,
  icon,
  title,
  body,
  time,
  isRead,
  orderId,
  onRead,
}: NotificationItemProps) {
  const meta = TYPE_META[type] ?? TYPE_META.system;

  return (
    <li
      className={`yc-fade-up yc-card-hover flex items-start gap-4 rounded-card border p-4 ${
        isRead
          ? "bg-white border-background-200"
          : "bg-primary-50/50 border-primary-200"
      }`}
    >
      <span
        className={`w-11 h-11 flex items-center justify-center rounded-full text-lg shrink-0 ${meta.tone}`}
      >
        <i className={icon}></i>
      </span>

      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-2 min-w-0">
            <h3 className="text-sm font-bold text-foreground-950 truncate">
              {title}
            </h3>
            {!isRead && (
              <span className="w-2 h-2 rounded-full bg-primary-500 shrink-0"></span>
            )}
          </div>
          <span className="shrink-0 text-xs text-foreground-400 whitespace-nowrap">
            {time}
          </span>
        </div>
        <p className="mt-1.5 text-sm leading-7 text-foreground-600">{body}</p>
        <div className="mt-3 flex items-center gap-3">
          <span
            className={`rounded-full px-2.5 py-1 text-[11px] font-semibold whitespace-nowrap ${meta.tone}`}
          >
            {meta.label}
          </span>
          {orderId && (
            <Link
              to={`/orders/${orderId}`}
              onClick={() => onRead(id)}
              className="inline-flex items-center gap-1 text-xs font-semibold text-foreground-700 hover:text-primary-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-external-link-line"></i>
              </span>
              عرض الطلب #{orderId}
            </Link>
          )}
          {!isRead && (
            <button
              type="button"
              onClick={() => onRead(id)}
              className="inline-flex items-center gap-1 text-xs font-semibold text-primary-600 hover:text-primary-700 transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-check-double-line"></i>
              تعليم كمقروء
            </button>
          )}
        </div>
      </div>
    </li>
  );
}